import type { HistoryCachedPayload } from '@/types';

/** Builds an insert payload row for Supabase `workouts`. */
export function buildWorkoutInsertRow(
  userId: string,
  cached: HistoryCachedPayload,
  prompt: string,
): { user_id: string; name: string; data_json: HistoryCachedPayload; prompt: string } {
  return {
    user_id: userId,
    name: cached.workoutName,
    data_json: cached,
    prompt,
  };
}
